//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Header',
  props: {
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    hasArrow: {
      type: Boolean,
      default: true
    },
    bgTransparent: {
      type: Boolean,
      default: false
    },
    routeHop: {
      type: Function,
      default: function _default() {
        return window.history.back();
      }
    },
    headerTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    title: function title() {
      return this.$route.meta.title || '';
    }
  },
  methods: {
    onClickLeft: function onClickLeft() {
      // 如果是app内直接使用goBackPage返回
      this.$Utils.appInfo ? this.$App.goBackPage() : this.routeHop();
    }
  }
};